// extracted by mini-css-extract-plugin
export default {"scanner":"scanner_scanner__8maXi"};